import { CreditCardStoreService } from '@hb/modules/financial-obligations/credit-card/credit-card-store.service';
import { CoApplicantPipe } from '@hb/modules/global';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { GlobalControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentPipe } from '@ap/content';
import { ApButtonGroupComponent, ApButtonGroupItemComponent } from '@ap/button';

@Component({
    selector: 'credit-card-multiple-installments',
    imports: [CoApplicantPipe, ReactiveFormsModule, ApContentPipe, ApButtonGroupComponent, ApButtonGroupItemComponent],
    templateUrl: './credit-card-multiple-installments.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: CreditCardStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.CREDIT_CARD_BUTTON_GROUP }
    ]
})
export class CreditCardMultipleInstallmentsComponent extends GlobalInjectComponent<CreditCardStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(CreditCardStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new GlobalControl<string>(
            this.analyticsService,
            this.questionKey,
            this.store.getMultipleInstallments()?.toString()
        );
        this.mainApplicantControl.onUpdate().subscribe((value) => this.store.setMultipleInstallments(Boolean(JSON.parse(value))));
    }

    onButtonGroupClicked($event: string): void {
        this.mainApplicantControl.setValue($event);
    }
}
